namespace GeniuzPOS.AdvPromo {
    export interface VwAdvPromoBasicAndAdvActiveByPluRow {
        Id?: string;
        PromoType?: string;
        PluCode?: string;
        PromoCampaign?: string;
        PmId?: string;
        PmGroupId?: string;
        PmGroupDesc?: string;
        PmType?: number;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: number;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: number;
        PromoDay?: string;
        PromoShopFg?: number;
        PromoShop?: string;
        PromoCustFg?: number;
        PromoCust?: string;
        VenderSharing?: number;
        PromoStatus?: number;
    }

    export namespace VwAdvPromoBasicAndAdvActiveByPluRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PmGroupDesc';
        export const localTextPrefix = 'AdvPromo.VwAdvPromoBasicAndAdvActiveByPlu';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PromoType = "PromoType",
            PluCode = "PluCode",
            PromoCampaign = "PromoCampaign",
            PmId = "PmId",
            PmGroupId = "PmGroupId",
            PmGroupDesc = "PmGroupDesc",
            PmType = "PmType",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoCust = "PromoCust",
            VenderSharing = "VenderSharing",
            PromoStatus = "PromoStatus"
        }
    }
}
